import styled from 'react-emotion/macro';
import { Icon } from 'antd';
import {
  width, height, space, color, fontSize,
} from 'styled-system';

export const CardWrapper = styled.div`
  ${width}
  ${height}
  ${space}
  ${color}

  text-align: center;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: 'proxima-nova', sans-serif;
  flex-direction: column;
  overflow: hidden;

  ${props => props.onClick && `
    cursor: pointer;
    
    &:hover {
      -webkit-box-shadow:inset 0px 6px 0px -2px ${props.hoverColor};
      -moz-box-shadow:inset 0px 6px 0px -2px ${props.hoverColor};
      box-shadow:inset 0px 6px 0px -2px ${props.hoverColor};
    }
  `}

  ${props => props.active && `
    -webkit-box-shadow:inset 0px 6px 0px -2px ${props.hoverColor};
    -moz-box-shadow:inset 0px 6px 0px -2px ${props.hoverColor};
    box-shadow:inset 0px 6px 0px -2px ${props.hoverColor};
  `}
`;

export const CardInner = styled.div`
  ${width}
  ${height}
  ${space}
  ${color}

  h2 {
    ${fontSize}
    color: #aaa;
    letter-spacing: 2px;
    max-width: 80px;
  }

  display: flex;
  align-items: center;
  font-family: 'proxima-nova', sans-serif;
`;

export const TextWrapper = styled('section')`
  display: flex;
  align-items: center;
`;

export const HeroText = styled('h1')`
  ${color}
  ${fontSize}

  font-weight: bold;
  margin: 0;
`;

export const RelatedText = styled('h2')`
  ${color}
  ${space}
  ${fontSize}
  text-align: left;
`;

export const ColoredIcon = styled(Icon)` &&& {
  ${color}
  ${space}
  margin-left: 0.2em;
  white-space: nowrap
}`;

export const DescriptiveText = styled('h5')`
  ${color}
  ${space}
  ${fontSize}
  
  letter-spacing: 1px;
  text-align: left;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  position: absolute;

  i {
    font-size: 150%;
  }
`;

export const ClickableIcon = styled(Icon)` &&& {
  position: absolute;
  top: 16px;
  right: 16px;
  ${color}
  ${space}
  ${fontSize}
}`;
